// 版本号管理文件
// 从package.json中获取当前版本号
export const VERSION = process.env.VITE_APP_VERSION || "1.0.0";
